module.exports = __webpack_public_path__ + "img/Introduction_picture01.93c55602.jpg";